import { render } from "./DomainGreenlist.vue?vue&type=template&id=70076054&scoped=true&ts=true"
import script from "./DomainGreenlist.vue?vue&type=script&lang=ts"
export * from "./DomainGreenlist.vue?vue&type=script&lang=ts"

import "./DomainGreenlist.vue?vue&type=style&index=0&id=70076054&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70076054"]])

export default __exports__